import { render } from "./ClientBuyPhoneNo.vue?vue&type=template&id=66292a57"
import script from "./ClientBuyPhoneNo.vue?vue&type=script&lang=js"
export * from "./ClientBuyPhoneNo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__